//============================
//# imbokreprowitem 
//============================

export default interface GeneralLedgerRiportRowItem {
  id: number;
  name: string;
  sign: boolean;
  reportRow: number;
  isBalance: boolean;
  accSign: boolean;
  accNo: string;
  dimcode1: string | null;
  rowType: number;
  total: number;
  isBalanceSign: boolean;
  isCashFlow: boolean;

  inEdit: boolean;
  details: boolean;
}

export const GeneralLedgerRiportRowItemDefaultProps: GeneralLedgerRiportRowItem = {
  id: 0,
  name: "-",
  sign: true,
  reportRow: 0,
  isBalance: true,
  accSign: false,
  accNo: "",
  dimcode1: null,
  rowType: 13,
  total: 0,
  isBalanceSign: true,
  isCashFlow: true,

  inEdit: false,
  details: false,
}